export default __webpack_public_path__ + "static/media/arrow-long-right.4d5a9463.svg";